module.exports = __webpack_public_path__ + "assets/img/gutters-1.2e4125ff.jpg";